module.exports = __webpack_public_path__ + "static/img/logo-atlassian.3dc00559.svg";